(function () {
  'use strict';

  angular.module('dashboard.project.overview', ['ngResource']);
})();
